// @core/api/endpoints/form/resolve_form_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveFormContextRequest,
  ResolveFormContextResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Resolve form context
 * Resolves the effective form policy for a scope entity by merging the policy hierarchy. Returns merged policy and available templates.
 */
export async function ResolveFormContext(
  data: ResolveFormContextRequest,
  options?: RequestOptions
): Promise<ResolveFormContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/forms/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveFormContextResponse>(requestPath, data, requestOptions);
}
